import React, { useContext, useState, useEffect } from 'react';
import { FormWrapper, 
         ButtonStyled,
         ButtonTextStyled } from './styles';
import { ContentContext } from '../../context/ContentContext';
import { validateEmail } from '../helpers/functions';
import { IoClose } from "react-icons/io5";
import { CircularProgress } from '@mui/material';
import { IoEye, IoEyeOff } from "react-icons/io5";

const FormLogin = (props) => {
    
    const { dataSaved, 
            setDataSaved,
            showLogin,
            setShowLogin,
            setShowRegistro,
            setShowForgot,
            setScope,
            trigger,
            setOpenSnackbar,
            setSnackbarMessage,
            setSnackbarVariant } = props;

    const { provinces,
            login } = useContext(ContentContext);

    const [ formData, setFormData ] = useState({ email: { value:"", error: false, mandatory: true },
                                                 password: { value:"", error: false, mandatory: true }, });
                                                 
    const [ isLoading, setIsLoading ] = useState(false);
    const [ showPassword, setShowPassword ] = useState(false);

    const handleOnChanceForm = (e, name) => {
        
        let formData_update = {...formData};

        formData_update[name].value = e.target.value;

        switch (name) {
            case "name":
                //formData_update[name].value = e.target.value;
                break;
        
            default:
                break;
        }

        setFormData(formData_update);

    }

    const handleSaveData = () => {

        setIsLoading(true);
        let haveError = false;

        let formDataValidate = {...formData};
        Object.keys(formDataValidate).map((field) => {
            
            if(formDataValidate[field].mandatory){
                if(!formDataValidate[field].value.length){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
            }

            if(field === "email"){
                if(!validateEmail(formDataValidate[field].value)){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
                console.log(validateEmail(formDataValidate[field].value));
            }
            
            
        })
        setFormData(formDataValidate);

        if(!haveError){
            const payload = {email: formData.email.value, password: formData.password.value};
            const response = login(payload);
            response.then(res => {
                setIsLoading(false);
                if(res.data.success){
                    setOpenSnackbar(true);
                    setSnackbarMessage("Bienvenido a Mercado Rural");
                    setSnackbarVariant("success");

                    setShowLogin(false);       
                    setShowRegistro(false); 
                    setShowForgot(false);
                    setScope(null);
                    //trigger();

                }else{
                    setOpenSnackbar(true);
                    setSnackbarMessage("Los datos ingresador no coinciden con un usuario registrado.");
                    setSnackbarVariant("error");
                    setIsLoading(false);

                }
                console.log("🚀 sendLogin", res)
            })
        }else{
            setIsLoading(false);
        }
        console.log("formData", formData);

    }

    const handleClose = () => {
        setScope(null);
    }

    const handleGotoRegistro = () => {
        setShowLogin(false);
        setShowRegistro(true);
        setShowForgot(false);
    }

    const handleGotoForgot = () => {
        setShowLogin(false);
        setShowRegistro(false);
        setShowForgot(true);
    }
    
    const handleShowPass = (field) => {

        switch (field) {
            case "password":
                setShowPassword(!showPassword)
                break;
            default:
                break;
        }
    }

    useEffect(() => {
      console.log("provinces", provinces)
    
      return () => {}
    }, [provinces])
    

    return (
        <FormWrapper>
            <div className='inner'>
                <div className='bt_close' onClick={handleClose}>
                    <p><IoClose /></p>
                </div>
                <div className='fields'>
                    <div className='field'>
                        <label>E-Mail {formData.email.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.email.error ? " error" : ""}`}
                            type="text" 
                            value={formData.email.value} 
                            onChange={(e) => handleOnChanceForm(e, "email")}
                        />
                    </div>
                    <div className='field'>
                        <label>Contraseña {formData.password.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.password.error ? " error" : ""}`}
                            type={showPassword ? "text" : "password"} 
                            value={formData.password.value} 
                            onChange={(e) => handleOnChanceForm(e, "password")}
                        />
                        <div className='show_pass' onClick={() => handleShowPass("password")}>
                            {!showPassword ?
                            <IoEye />
                            : 
                            <IoEyeOff />
                            }
                        </div>
                    </div>
                </div>

                <div className='aclaration_asterix'>Los campos con * son obligatorios</div>
                
                <div className='actions'>
                    <ButtonTextStyled 
                        className='bt_forgot'
                        onClick={() => handleGotoForgot()}
                    >
                        Olvidaste tu contraseña?
                    </ButtonTextStyled>
                    {!isLoading ? 
                        <ButtonStyled onClick={() => handleSaveData()}>
                            Enviar
                        </ButtonStyled>
                    :
                        <div className='loader'>
                            <CircularProgress />
                        </div>
                    }
                    <ButtonTextStyled onClick={() => handleGotoRegistro()}>
                        REGISTRATE
                    </ButtonTextStyled>
                </div>
            </div>
        </FormWrapper>
    );
};

export default FormLogin;